import { render, staticRenderFns } from "./profileAlg.vue?vue&type=template&id=c1b3f770&scoped=true"
import script from "./profileAlg.vue?vue&type=script&lang=js"
export * from "./profileAlg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1b3f770",
  null
  
)

export default component.exports